import React, { useEffect, useState } from 'react'
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang'
import ReactLoading from "react-loading";
import CardStatementReport from './CardStatementReport'
import CardStatisticsReport from './CardStatisticsReport'
import { useParams } from 'react-router-dom'
import { emptyStatementsByAccount, emptyStatementsReportByAccount, loadStatementsByAccount, loadStatementsReportByAccount } from '../../../../store/Actions/ActionAccounts'
import { useSelectorCustom } from '../../../../components/general/general-component/abstruct-component/useSelectorCustom'
import CardExpensesReport from './CardExpensesReport'
import select from '../../../../assets/images/select.png'
import AccountInfo from './AccountInfo';
import { formatNumberWithCommas } from '../../../../components/general/general-component/abstruct-component/FunctionRemoveCommas';

function ReportAccounts() {
  const { dispatch, langLocal, navigate } = AbstructVar()
  const { translate } = AbstructLang()
  const [load, setLoad] = useState(false)
  const { statementsByAccount, loadingStatementsByAccount, dataReport, loadingDataReport, currency } = useSelectorCustom()
  const [selectedIds, setSelectedIds] = useState([]);
  let { id } = useParams()
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(loadStatementsByAccount(id))
    return (() => {
      dispatch(emptyStatementsByAccount())
      dispatch(emptyStatementsReportByAccount())
    })
  }, [])
  const handleCheckboxChange = (id) => {
    setSelectedIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(id)) {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      } else {
        return [...prevSelectedIds, id];
      }
    });
  };
  const data = [
    {
      id: 1,
      statement_date: "2024-05-05",
      number: "EXP000001",
      project: {
        id: 1,
        name: "Innovative Project Alpha",
      }
    },
    {
      id: 2,
      statement_date: "2024-05-05",
      number: "EXP000001",
      project: {
        id: 1,
        name: "Innovative Project Alpha",
      }
    },
    {
      id: 3,
      statement_date: "2024-05-05",
      number: "EXP000001",
      project: {
        id: 1,
        name: "Innovative Project Alpha",
      }
    },
    {
      id: 4,
      statement_date: "2024-05-05",
      number: "EXP000001",
      project: {
        id: 1,
        name: "Innovative Project Alpha",
      }
    },
  ]
  return (
    <main>
      <div className="margin_main shadow_main " style={{ backgroundColor: "white", borderRadius: "5px" }} dir={langLocal == "ar" ? "rtl" : "ltr"} >
        <AccountInfo data={statementsByAccount[0]?.account} />
        <div className='report-account' >
          <div className='left-report-account' >
            <div className='top-left-report-account' >
              <span>{translate('statements')}</span>
              <button onClick={() => {
                dispatch(emptyStatementsReportByAccount())
                dispatch(loadStatementsReportByAccount(id, selectedIds, setLoad))
              }} >{load ? translate('loading') : translate('show')}</button>
            </div>
            {console.log(selectedIds)}
            <div style={{ maxHeight: "600px", overflowY: "auto", padding: "0px 20px" }} >
              {
                !loadingStatementsByAccount ? (
                  statementsByAccount?.map((datum) => {
                    return (
                      <CardStatementReport selectedIds={selectedIds} handleCheckboxChange={handleCheckboxChange} langLocal={langLocal} translate={translate} datum={datum} />
                    )
                  })
                ) : <div className='loading-statement' >
                  <ReactLoading
                    type="spin"
                    color="#1C5E91"
                    height={"8%"}
                    width={"8%"}
                  />
                </div>
              }
            </div>
          </div>
          {console.log(dataReport)}
          {console.log(loadingDataReport)}
          {
            dataReport && !loadingDataReport && (
              <div className='right-report-account'>
                <center><span className='title-right-report-account' >{translate('statistics')}</span></center>
                <div className='cards-statistics-report-account' >
                  <CardStatisticsReport title={translate('expenses_count')} number={dataReport?.statistics?.total_expenses_count} width />
                  <CardStatisticsReport title={translate('total_statements')} number={dataReport?.statistics?.total_statements} width />
                  {/* <CardStatisticsReport title={translate('total_expenses_revolved_count')}
                    number={` ${formatNumberWithCommas(dataReport?.statistics?.total_expenses_revolved_count)}  ${translate(currency)} `} width />
                  <CardStatisticsReport title={translate('total_expenses_amount_with_revolving')}
                    number={`${formatNumberWithCommas(dataReport?.statistics?.total_expenses_amount_with_revolving)} ${translate(currency)}`} width /> */}
                  <CardStatisticsReport title={translate('max_expense_amount')}
                    number={dataReport?.statistics?.max_expense_amount !== null ?
                      `${formatNumberWithCommas(dataReport?.statistics?.max_expense_amount)}  ${translate(currency)}` : `0 ${translate(currency)}`} width />

                  <CardStatisticsReport title={translate('min_expense_amount')}
                    number={
                      dataReport?.statistics?.min_expense_amount !== null ?
                        `${formatNumberWithCommas(dataReport?.statistics?.min_expense_amount)}  ${translate(currency)}` : `0 ${translate(currency)}`} width />

                  <CardStatisticsReport title={translate('total_expenses_amount_without_revolving')}
                    number={`${formatNumberWithCommas(dataReport?.statistics?.total_expenses_amount_without_revolving)} ${translate(currency)}`} width_100 />

                </div><br />
                <center><span className='title-right-report-account' >{translate('expenses')}</span></center>
                <div className='cards-expenses-report-account' >
                  {
                    dataReport?.expenses?.map((expense) => {
                      return (
                        <CardExpensesReport langLocal={langLocal} expense={expense} translate={translate} />
                      )
                    })
                  }
                </div>
              </div>
            )
          }
          {
            load && (
              <div className='right-report-account' style={{ display: "flex", marginTop: "-150px", flexDirection: "column", alignItems: "center", justifyContent: "center" }} >
                <ReactLoading
                  type="spin"
                  color="#1C5E91"
                  height={"5%"}
                  width={"5%"}
                />
              </div>
            )
          }
          {
            dataReport === null && loadingDataReport && !load && (
              <div className='right-report-account' style={{ display: "flex", marginTop: "-150px", flexDirection: "column", alignItems: "center", justifyContent: "center" }} >
                <img src={select} />
                <span className='select-statment' style={{ marginTop: "20px" }} >Select Statments</span>
              </div>
            )
          }
        </div>
      </div>
    </main>
  )
}

export default ReportAccounts